<!-- 租控台账 -->
<template>
  <div class="rent-ledger-container">
    <!-- 1. 顶部统计卡片 -->
    <div class="statistics-row">
      <div v-for="(item, index) in summaryCards" :key="index" class="stat-card">
        <div class="stat-label">{{ item.label }}</div>
        <div class="stat-value" :style="{ color: item.color }">
          {{ item.value }} <span class="arrow">个</span>
        </div>
      </div>
    </div>
    <!-- 2. 搜索筛选栏 -->
    <div class="filter-wrapper">
      <el-form :inline="true" :model="filters" size="small" class="search-form">
        <el-form-item label="资源编号/名称:">
          <el-input
            v-model="filters.resourceNoAndName"
            placeholder="请输入"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属项目:">
          <el-select
            v-model="filters.communityId"
            placeholder="请选择"
            style="width: 150px"
          >
            <el-option
              label="南京软件谷A栋"
              value="2025072783670006"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资源类型:">
          <el-select
            v-model="filters.resourceType"
            placeholder="请选择"
            style="width: 150px"
          >
            <el-option
              v-for="(item, index) in resourceTypeList"
              :label="item.name"
              :value="item.value"
              :key="index"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="租控状态:">
          <el-select
            v-model="filters.currentStatus"
            placeholder="请选择"
            clearable
            style="width: 120px"
          >
            <el-option
              v-for="(item, index) in currentStatusList"
              :label="item.name"
              :value="item.value"
              :key="index"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search()"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" @click="clear()">重置</el-button>
          <el-button icon="el-icon-upload2">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 3. 数据表格 -->
    <div class="table-content">
      <el-table
        :data="ledgerList"
        border
        stripe
        style="width: 100%"
        size="mini"
        :header-cell-style="{
          backgroundColor: '#f9f9f9',
          color: '#333',
          fontWeight: 'bold',
        }"
      >
        <el-table-column
          prop="resourceNo"
          label="资源编号"
          width="120"
          align="center"
        />
        <el-table-column
          prop="resourceName"
          label="资源名称"
          min-width="150"
          align="center"
        />
        <el-table-column
          prop="resourceType"
          label="资源类型"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            {{ _commonFormatter(scope.row, "resourceType") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="communityName"
          label="所属项目"
          min-width="130"
          align="center"
        />
        <el-table-column
          prop="buildingName"
          label="楼栋"
          width="60"
          align="center"
        />
        <el-table-column
          prop="area"
          label="面积(㎡)"
          width="80"
          align="center"
        />
        <el-table-column
          prop="rentPrice"
          label="租金单价"
          width="100"
          align="center"
        />

        <!-- 租控状态列 (带颜色标签) -->
        <el-table-column
          label="租控状态"
          prop="currentStatus"
          width="90"
          align="center"
        >
          <template slot-scope="scope">
            <span :class="['status-tag', 'tag-' + scope.row.currentStatus]">
              {{ _commonFormatter(scope.row, "currentStatus") }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="partyBName"
          label="租客名称"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="partyBPhone"
          label="租客电话"
          width="110"
          align="center"
        />

        <!-- 合同/意向书列 (蓝色标签) -->
        <el-table-column label="合同/意向书" width="120" align="center">
          <template slot-scope="scope">
            <!-- scope.row.contractType === "INTENTION" ? "意向书" : "合同" -->
            <span
              v-if="scope.row.contractId"
              :class="[
                'contract-tag',
                scope.row.contractType === 'INTENTION' ? 'type-yxs' : '',
              ]"
            >
              {{ scope.row.contractType === "INTENTION" ? "意向书" : "合同" }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="signDate"
          label="签约日期"
          width="100"
          align="center"
        />
        <el-table-column
          prop="expiryDate"
          label="到期日期"
          width="100"
          align="center"
        />
        <el-table-column
          prop="price"
          label="月租金"
          width="90"
          align="center"
        />

        <!-- 缴费状态列 (绿色/红色) -->
        <el-table-column label="缴费状态" width="90" align="center">
          <template slot-scope="scope">
            <span
              v-if="scope.row.paymentStatus"
              :class="['pay-status', 'text-' + scope.row.paymentStatus]"
            >
              {{ _commonFormatter(scope.row, "paymentStatus") }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="showDetail(scope)">
              查看
            </el-button>
            <!-- <el-button v-if="scope.row.contract" type="text" size="mini">
              查看合同
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 4. 分页器 -->
      <div class="pagination-bar">
        <span>共 {{ ledgerTotal }} 条</span>
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="currentPageSize"
          layout="prev, pager, next, sizes"
          :total="ledgerTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 租控台账右侧抽屉 -->
    <el-drawer
      :visible.sync="ledgerDrawerVisible"
      direction="rtl"
      size="45%"
      :with-header="false"
      custom-class="ledger-custom-drawer"
    >
      <div class="ledger-drawer-content">
        <!-- 头部标题区 -->
        <div class="ledger-drawer-header">
          <div class="header-left">
            <i
              class="el-icon-close close-btn"
              @click="ledgerDrawerVisible = false"
            ></i>
            <span class="title"
              >{{ currentResourceNo }} - {{ currentResourceName }}</span
            >
          </div>
        </div>

        <!-- 标签页 -->
        <div class="ledger-tabs-wrapper">
          <el-tabs v-model="activeLedgerTab" @tab-click="handleLedgerTabClick">
            <el-tab-pane label="资源信息" name="resourceInfo"></el-tab-pane>
            <el-tab-pane label="租赁信息" name="leaseInfo"></el-tab-pane>
          </el-tabs>
        </div>

        <!-- 主体滚动内容区 -->
        <div class="ledger-scroll-body">
          <!-- =========== 页签1: 资源信息 (对应图1) =========== -->
          <div
            v-show="activeLedgerTab === 'resourceInfo'"
            class="ledger-tab-panel"
          >
            <div class="ledger-section-card">
              <h3 class="ledger-section-title">基本信息</h3>
              <div class="ledger-info-grid">
                <div
                  v-for="(item, index) in ledgerResourceData"
                  :key="index"
                  class="ledger-info-item"
                >
                  <div class="ledger-info-label">{{ item.label }}</div>
                  <div class="ledger-info-value">
                    <span
                      v-if="
                        item.key === 'resourceType' ||
                        item.key === 'currentStatus'
                      "
                      :class="['status-' + item.value]"
                      >{{ _commonFormatterValue(item.value, item.key) }}</span
                    >
                    <span v-else>{{ item.value }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- =========== 页签2: 租赁信息 (对应图2) =========== -->
          <div
            v-show="activeLedgerTab === 'leaseInfo'"
            class="ledger-tab-panel"
          >
            <div class="ledger-section-card">
              <h3 class="ledger-section-title">租赁信息</h3>
              <div class="ledger-info-grid">
                <div
                  v-for="(item, index) in ledgerLeaseData"
                  :key="index"
                  class="ledger-info-item"
                >
                  <div class="ledger-info-label">{{ item.label }}</div>
                  <div class="ledger-info-value">
                    <span v-if="item.key === 'docType'" class="tag-doc-blue">{{
                      item.value
                    }}</span>
                    <span
                      v-else-if="item.key === 'paymentStatus'"
                      :class="['text-' + item.value]"
                      >{{ _commonFormatterValue(item.value, item.key) }}</span
                    >
                    <span v-else>{{ item.value }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 底部操作按钮 -->
            <!-- <div class="ledger-footer-actions">
              <el-button type="primary" size="medium">查看完整合同</el-button>
            </div> -->
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState, mapActions, mapMutations } from "vuex";
import {
  filterEmptyFields,
  mapValuesToArray,
  commonFormatter,
  commonFormatterValue,
} from "../../utils/tool.js";
import { formatDate } from "../../utils/dateUtil.js";

const TAG = "租控台账";
export default {
  name: "RentLedger",
  data() {
    return {
      currentResourceNo: "",
      currentResourceName: "",
      currentPage: 1,
      currentPageSize: 10,
      summaryCards: [
        {
          label: "总资源数",
          value: "",
          key: "totalCount",
          color: "#409EFF",
        },
        {
          label: "已出租",
          value: "",
          key: "rentedCount",
          color: "#67C23A",
        },
        {
          label: "空置可租",
          value: "",
          key: "availableCount",
          color: "#E6A23C",
        },
        {
          label: "装修中",
          value: "",
          key: "renovatingCount",
          color: "#722ed1",
        },
        {
          label: "已预订",
          value: "",
          key: "reservedCount",
          color: "#409EFF",
        },
        {
          label: "本月到期",
          value: "",
          key: "expiringCount",
          color: "#F56C6C",
        },
      ],

      // 搜索表单对象
      filters: {
        resourceNoAndName: "", // 资源编号/名称
        communityId: "", // 所属项目
        resourceType: "", // 资源类型
        currentStatus: "", // 租控状态
      },

      // ----------------------------租控台账--------------------------
      // 控制租控台账抽屉显示
      ledgerDrawerVisible: false,

      // 当前激活的页签
      activeLedgerTab: "resourceInfo",

      currentDetail: {},
      // 页签一：资源信息数据配置 (严格按照图片文本顺序)
      ledgerResourceData: [
        { label: "资源编号", value: "", key: "resourceNo" },
        { label: "资源名称", value: "", key: "resourceName" },
        { label: "资源类型", value: "", key: "resourceType" },
        { label: "所属项目", value: "", key: "communityName" },
        { label: "楼栋", value: "", key: "floorName" },
        { label: "楼层", value: "", key: "floorNum" },
        { label: "单元", value: "", key: "" },
        { label: "面积", value: "", key: "floorArea" },
        { label: "租金单价", value: "", key: "rentPrice" },
        { label: "租控状态", value: "", key: "currentStatus" },
      ],

      // 页签二：租赁信息数据配置 (严格按照图片文本顺序)
      ledgerLeaseData: [
        { label: "租客名称", value: "", key: "partyBName" },
        { label: "租客电话", value: "", key: "partyBPhone" },
        { label: "文档类型", value: "", key: "?" },
        { label: "合同/意向书编号", value: "", key: "contractType" },
        { label: "签约日期", value: "", key: "signDate" },
        { label: "到期日期", value: "", key: "expiryDate" },
        { label: "月租金", value: "", key: "price" },
        { label: "缴费状态", value: "", key: "paymentStatus" },
      ],
    };
  },

  computed: {
    ...mapState("asset", [
      "ledgerTotal", // 租控台账统计列表总个数
      "ledgerList", // 租控台账列表
      "resourceTypeList", // 资源类型
      "currentStatusList", // 租控状态
    ]),
  },

  mounted() {
    this.init();
  },
  methods: {
    ...mapActions("asset", [
      "getRentalLedgerHandler", // 获取租控台账列表
      "getStatisticsHandler", // 获取统计数据
      "getrentalDetailHandler", // 获取统计数据
    ]),

    /**
     * 初始化函数
     */
    init() {
      this.search();

      const params = {
        communityId: "2025072783670006", //所属项目
        floorId: "", // 楼栋ID
        resourceType: "", // 资源类型
      };

      const noEmptyParams = filterEmptyFields(params);
      this.getStatisticsHandler(noEmptyParams).then((obj) => {
        this.summaryCards = mapValuesToArray(this.summaryCards, obj);
        console.log(TAG, "init this.summaryCards=", this.summaryCards);
      });
    },

    handleSizeChange(val) {
      console.log(TAG, "handleSizeChange: val=", val);
      this.currentPageSize = val;
      this.search();
    },

    handleCurrentChange(val) {
      console.log(TAG, "handleCurrentChange: val=", val);
      this.currentPage = val;
      this.search();
    },

    /**
     * 查询
     */
    search() {
      const params = {
        pageNum: this.currentPage,
        pageSize: this.currentPageSize,
      };

      Object.assign(params, this.filters);

      const noEmptyParams = filterEmptyFields(params);
      console.log(TAG, "search params=", JSON.stringify(noEmptyParams));
      this.getRentalLedgerHandler(noEmptyParams);
    },

    clear() {
      this.filters = {
        resourceNoAndName: "", // 资源编号/名称
        communityId: "", // 所属项目
        resourceType: "", // 资源类型
        currentStatus: "", // 租控状态
      };
      this.search();
    },

    _commonFormatter(row, field) {
      return commonFormatter(row, field);
    },

    _commonFormatterValue(value, key) {
      return commonFormatterValue(value, key);
    },

    showDetail({ row }) {
      this.openDrawer();
      this.setDetail(row);
    },

    setDetail(item) {
      const { resourceId } = item;
      this.getrentalDetailHandler(resourceId).then((detail) => {
        console.log(TAG, "setDetail detail=", detail);
        const { resourceNo, resourceName } = detail;
        this.currentResourceNo = resourceNo;
        this.currentResourceName = resourceName;

        Object.assign(detail, {
          expiryDate: formatDate(_.get(detail, "expiryDate")),
          effectiveDate: formatDate(_.get(detail, "effectiveDate")),
          signDate: formatDate(_.get(detail, "signDate")),
        });

        this.currentDetail = detail;
        this.ledgerResourceData = mapValuesToArray(
          this.ledgerResourceData,
          detail
        );
        this.ledgerLeaseData = mapValuesToArray(this.ledgerLeaseData, detail);
      });
    },

    handleLedgerTabClick(tab) {},

    //---------------抽屉式弹窗-----------------------

    openDrawer() {
      this.ledgerDrawerVisible = true;
    },
    closeDrawer() {
      this.ledgerDrawerVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 定义颜色变量（对应原图色值） */
$bg-body: #f4f6f9; // 全局底色
$bg-white: #ffffff; // 卡片白色背景
$text-sub: #909399; // 次要文字灰色
$color-primary: #409eff; // 品牌蓝 (总房源、已预订)
$color-success: #67c23a; // 成功绿 (已出租、缴费成功)
$color-warning: #e6a23c; // 警告橙 (空置)
$color-purple: #722ed1; // 装修紫
$color-danger: #f56c6c; // 危险红 (逾期、本月到期)
$border-color: #ebeef5; // 分割线边框

.rent-ledger-container {
  padding: 16px;
  background-color: $bg-body;
  min-height: 100vh;
  font-family: Arial, sans-serif;

  /* 顶部统计卡片 */
  .statistics-row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 20px;

    .stat-card {
      flex: 1;
      background: $bg-white;
      padding: 16px 20px;
      border-radius: 4px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

      .stat-label {
        font-size: 13px;
        color: $text-sub;
        margin-bottom: 8px;
      }
      .stat-value {
        font-size: 24px;
        font-weight: 500;
        .arrow {
          font-size: 16px;
          margin-left: 2px;
        }
      }
    }
  }

  /* 筛选区域 */
  .filter-wrapper {
    background: $bg-white;
    padding: 18px 20px 2px 20px;
    border-radius: 4px 4px 0 0;
    margin-bottom: 1px;
    text-align: left;

    .search-form {
      .el-form-item {
        margin-bottom: 16px;
      }
      ::v-deep .el-form-item__label {
        font-weight: bold;
      }
    }
  }

  // 已出租
  .status-RENTED {
    // background: $color-success;
    color: $color-success;
  }

  .tag-RENTED {
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    color: $color-success;
  }

  // 已预定
  .status-RESERVED {
    // background: #d3adf7;
    color: $color-purple;
  }

  // 已预定
  .tag-RESERVED {
    background: #f9f0ff;
    border: 1px solid #d3adf7;
    color: $color-purple;
  }

  // 装修中
  .status-RENOVATING {
    // background: #91d5ff;
    color: $color-primary;
  }

  // 装修中
  .tag-RENOVATING {
    background: #e6f7ff;
    border: 1px solid #91d5ff;
    color: $color-primary;
  }

  // 空闲可租
  .status-AVAILABLE {
    // background: #ffe58f;
    color: $color-primary;
  }

  // 空闲可租
  .tag-AVAILABLE {
    background: #fffbe6;
    border: 1px solid #ffe58f;
    color: $color-warning;
  }

  /* 表格区域 */
  .table-content {
    background: $bg-white;
    padding: 10px;
    border-radius: 0 0 4px 4px;

    /* 状态标签圆角矩形样式 */
    .status-tag {
      padding: 2px 8px;
      border-radius: 2px;
      font-size: 12px;
      display: inline-block;
    }

    /* 合同标签 */
    .contract-tag {
      background: #e6f7ff;
      color: $color-primary;
      padding: 0 4px;
      border: 1px solid #91d5ff;
      font-size: 11px;
      border-radius: 2px;
      &.type-yxs {
        background: #fffbe6;
        color: $color-warning;
        border-color: #ffe58f;
      }
    }

    /* 缴费状态颜色 */
    .pay-status {
      font-weight: bold;
    }

    .pagination-footer {
      margin-top: 15px;
      text-align: right;
    }
  }
}

.text-PAID {
  color: $color-success;
}
.text-OVERDUE {
  color: $color-danger;
}
.text-UNPAID {
  color: $color-danger;
}

/* 响应式适配：确保在平板端也能良好显示 */
@media screen and (max-width: 1400px) {
  .rent-ledger-container .statistics-row {
    flex-wrap: wrap;
    .stat-card {
      min-width: 30%;
    }
  }
}
@media screen and (max-width: 992px) {
  .rent-ledger-container .statistics-row .stat-card {
    min-width: 45%;
  }
}

/* 分页器样式 */
.pagination-bar {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  span {
    font-size: 13px;
    color: #606266;
    margin-right: 15px;
  }
}

/* =========== 租控台账专属 SCSS 变量定义 =========== */
$ldg-primary-color: #1890ff; /* 品牌主蓝色 */
$ldg-text-title: #303133; /* 标题主色 */
$ldg-text-content: #606266; /* 内容文字色 */
$ldg-text-label: #909399; /* 标签/边框辅助色 */
$ldg-border-line: #ebeef5; /* 基础边框灰色 */
$ldg-bg-label: #fbfbfb; /* 左侧Label背景色 */
$ldg-bg-main: #f5f7fa; /* 外部深色背景 */
$ldg-bg-content: #fafafa; /* 抽屉内主背景 */
$ldg-success-color: #67c23a; /* 绿色状态 */
$ldg-doc-blue: #409eff; /* 文档类型蓝色字 */

.ledger-custom-drawer {
  .ledger-drawer-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #fff;

    /* == 头部导航 == */
    .ledger-drawer-header {
      padding: 16px 20px;
      border-bottom: 1px solid $ldg-border-line;
      .header-left {
        display: flex;
        align-items: center;
        .close-btn {
          font-size: 18px;
          cursor: pointer;
          margin-right: 12px;
          color: $ldg-text-label;
          &:hover {
            color: $ldg-primary-color;
          }
        }
        .title {
          font-size: 16px;
          font-weight: 600;
          color: $ldg-text-title;
        }
      }
    }

    /* == Tabs 自定义样式 == */
    .ledger-tabs-wrapper {
      padding: 0 20px;
      ::v-deep .el-tabs__header {
        margin: 0;
      }
      ::v-deep .el-tabs__item {
        height: 50px;
        line-height: 50px;
        font-size: 13px;
      }
      ::v-deep .el-tabs__nav-wrap::after {
        height: 1px;
      }
    }

    /* == 滚动内容区 == */
    .ledger-scroll-body {
      flex: 1;
      overflow-y: auto;
      padding: 20px;
      background-color: $ldg-bg-content;

      .ledger-tab-panel {
        /* 卡片容器 */
        .ledger-section-card {
          background: #fff;
          border: 1px solid $ldg-border-line;
          border-radius: 4px;
          padding: 20px;
          margin-bottom: 20px;

          .ledger-section-title {
            margin: 0 0 16px 0;
            font-size: 14px;
            color: $ldg-text-title;
            font-weight: 600;
          }

          /* 信息网格：两列布局 */
          .ledger-info-grid {
            display: flex;
            flex-wrap: wrap;
            border-top: 1px solid $ldg-border-line;
            border-left: 1px solid $ldg-border-line;

            .ledger-info-item {
              display: flex;
              width: 50%;
              box-sizing: border-box;
              border-right: 1px solid $ldg-border-line;
              border-bottom: 1px solid $ldg-border-line;
              min-height: 44px;

              .ledger-info-label {
                width: 120px;
                background-color: $ldg-bg-label;
                padding: 10px 15px;
                color: $ldg-text-content;
                font-size: 13px;
                display: flex;
                align-items: center;
                border-right: 1px solid $ldg-border-line;
              }

              .ledger-info-value {
                flex: 1;
                padding: 10px 15px;
                font-size: 13px;
                color: $ldg-text-title;
                display: flex;
                align-items: center;

                /* 图1：已出租 纯文字 */
                .text-status-green {
                  color: $ldg-success-color;
                  font-weight: bold;
                }

                /* 图2：合同 文档Tag */
                .tag-doc-blue {
                  color: $ldg-doc-blue;
                  background-color: rgba(64, 158, 255, 0.1);
                  padding: 2px 8px;
                  border-radius: 2px;
                }

                /* 图2：已缴费 状态Tag */
                .tag-status-green {
                  color: $ldg-success-color;
                  background-color: rgba(103, 194, 58, 0.1);
                  padding: 2px 8px;
                  border-radius: 2px;
                }
              }
            }
          }
        } // end .ledger-section-card

        /* 底部操作区 (图2:查看完整合同) */
        .ledger-footer-actions {
          display: flex;
          justify-content: center;
          margin-top: 30px;
          .el-button {
            padding: 10px 24px;
          }
        }
      }
    }
  }
}

/* =========== 响应式适配 =========== */
@media screen and (max-width: 1400px) {
  ::v-deep .el-drawer {
    width: 60% !important;
  }
}
@media screen and (max-width: 900px) {
  ::v-deep .el-drawer {
    width: 90% !important;
  }
  .ledger-info-item {
    width: 100% !important; /* 小屏幕自动换为单列排布 */
  }
}
</style>
